export default {
  'pages.log.operation.title': 'Operation Log',
  'pages.log.operation.subtitle':
    'Records user operations in the system for tracing and auditing',

  // Columns
  'pages.log.operation.column.realName': 'Operator',
  'pages.log.operation.column.userName': 'Account',
  'pages.log.operation.column.operModule': 'Module',
  'pages.log.operation.column.operType': 'Operation Type',
  'pages.log.operation.column.requestMethod': 'Method',
  'pages.log.operation.column.requestUrl': 'Request URL',
  'pages.log.operation.column.ipAddress': 'IP Address',
  'pages.log.operation.column.operLocation': 'Location',
  'pages.log.operation.column.operStatus': 'Status',
  'pages.log.operation.column.execTime': 'Duration (ms)',
  'pages.log.operation.column.operTime': 'Operation Time',
  'pages.log.operation.column.operTimeRange': 'Operation Time Range',

  // Search
  'pages.log.operation.search.userName.placeholder': 'Fuzzy match',
  'pages.log.operation.search.operModule.placeholder': 'Fuzzy match',

  // Enums
  'pages.log.operation.operType.INSERT': 'Insert',
  'pages.log.operation.operType.UPDATE': 'Update',
  'pages.log.operation.operType.DELETE': 'Delete',
  'pages.log.operation.operType.SELECT': 'Query',
  'pages.log.operation.operType.OTHER': 'Other',
  'pages.log.operation.status.success': 'Success',
  'pages.log.operation.status.fail': 'Failed',
};
